import * as React from "react";

const PlusIcon = (props) => {
    return (
        <svg
          width={40}
          height={40}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={20} cy={20} r={20} fill="#282C34" />
          <path
            d="M25 20.713h-4.286v4.286h-1.428v-4.286H15v-1.429h4.286V15h1.428v4.285H25v1.429z"
            fill="#DFB342"
          />
        </svg>
      )
}

export default PlusIcon